import { Box } from '@material-ui/core';
import React from 'react';

export const HR = ({
  backgroundColor = 'rgb(138, 146, 159)',
  margin,
  size = 1,
}: {
  backgroundColor?: string;
  margin: number;
  size?: number;
}) => {
  return (
    <Box
      style={{
        height: size,
        backgroundColor,
        marginTop: `${margin}px`,
        marginBottom: `${margin}px`,
      }}
    />
  );
};
